import { render, staticRenderFns } from "./CNotificationsFromStore.vue?vue&type=template&id=7fb785c6"
import script from "./CNotificationsFromStore.vue?vue&type=script&lang=js"
export * from "./CNotificationsFromStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports